module.exports = __webpack_public_path__ + "static/media/Alabama 811 Square Logo.f2493f08.png";